if (!customElements.get("collection-facets")) {
  class CollectionFacets extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector("form");
      this.collection = document.querySelector("[data-type='Collection']");
      this.form.addEventListener("input", this.rerenderCollection.bind(this));
      this.form.addEventListener("submit", (e) => {
        e.preventDefault();
      })


      this.tagFilter = this.querySelector("[data-filter-type='tag']");
      this.currentTagFilterValue = this.tagFilter?.value;
      this.tagFilter?.addEventListener(
        "input",
        this.handleTagFilter.bind(this)
      );

      this.addEventListener(
        "rerenderCollection",
        this.rerenderCollection.bind(this)
      );
    }

    handleTagFilter() {
      const tagValue = this.tagFilter?.value;
      const currentPath = window.location.pathname;

      var url =
        this.currentTagFilterValue &&
        this.currentTagFilterValue !== "" &&
        currentPath.includes(this.currentTagFilterValue)
          ? currentPath.replace(this.currentTagFilterValue, tagValue)
          : currentPath + "/" + tagValue;
      if (url.endsWith("/")) {
        url = url.substring(0, url.length - 1);
      }

      this.updateUrl(url);
      this.rerenderCollection();

      this.currentTagFilterValue = tagValue;
    }

    getFormParameters() {
      const formData = new FormData(this.form);
      const urlParams = new URLSearchParams(window.location.search);
      for (var pair of formData.entries()) {
        urlParams.set(pair[0], pair[1]);
      }
      return urlParams;
    }

    createRerenderParameters() {
      const formParameters = this.getFormParameters();
      const sectionId = this.collection.getAttribute("data-id");
      formParameters.append("section_id", sectionId);
      return formParameters;
    }

    updateUrl(url = window.location.pathname) {
      const formParams = this.getFormParameters();
      const result = {};
      for (const [key, value] of formParams) {
        result[key] = value;
      }
      console.log("UPDATING TO " + `${url}?${formParams.toString()}`);
      history.pushState({ result }, "", `${url}?${formParams.toString()}`);
    }

    async fetchCollection() {
      const params = this.createRerenderParameters();
      const url = `${window.location.pathname}?${params}`;
      const res = await fetch(url);
      const text = await res.text();

      return text;
    }

    parsePlainToElement(html) {
      const parser = new DOMParser();
      var resAsHtml = parser.parseFromString(html, "text/html");
      return resAsHtml;
    }

    async rerenderCollection() {
      this.updateUrl();
      const text = await this.fetchCollection();
      const collectionElement = this.parsePlainToElement(text);
      const collection = collectionElement.querySelector(
        "[data-type='Collection']"
      );

      this.collection.innerHTML = collection.innerHTML;

      if (typeof createYotpoScript === "function") {
        createYotpoScript();
      }

      //document.querySelector("variant-picker").reinitListeners();

      // Check if Yotpo is loaded and refresh the widgets
      if (typeof yotpo !== "undefined" && yotpo.refreshWidgets) {
        yotpo.refreshWidgets();
        console.log("Yotpo widgets refreshed after collection re-render.");
      } else {
        console.error(
          "Yotpo is not defined or not yet loaded. Ensure the script is loaded correctly."
        );
      }
    }
  }

  customElements.define("collection-facets", CollectionFacets);
}

if (!customElements.get("collection-pagination")) {
  class CollectionPagination extends HTMLElement {
    constructor() {
      super();

      this.collectionFacets = document.querySelector("collection-facets");

      this.querySelectorAll(".page a").forEach((pageEl) => {
        pageEl.addEventListener("click", (e) => {
          e.preventDefault();
          const number = parseInt(pageEl.textContent);
          this.switchPage(number);
        });
      });
    }

    rerenderCollection() {
      this.collectionFacets.dispatchEvent(
        new CustomEvent("rerenderCollection")
      );
    }

    switchPage(number) {
      const urlSearch = new URLSearchParams(window.location.search);
      urlSearch.set("page", number);
      history.pushState(
        { page: number },
        "",
        `${window.location.pathname}?${urlSearch.toString()}`
      );
      this.rerenderCollection();

      const top = window.innerWidth >= 768 ? 250 : 420;
      window.scroll({
        top: top,
        behavior: "smooth",
      });
    }

    initVariantPicker() {
      setTimeout(() => {
        const variantPicker = document.querySelector("variant-picker");
        variantPicker.setupVariantPicker();
      }, 300);
    }
  }

  customElements.define("collection-pagination", CollectionPagination);
}
